<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deletePurpose" :renderDelete="(identifier != null ? true : false)" :isDeleting="isDeleting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Code:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Code" v-model="purpose.code" :readonly="identifier != null"/>
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Name:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="100" placeholder="Name" v-model="purpose.name" />
									</div>
								</div>
	
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Status:</label>
									</div>
												
									<div class="col-md-6">
										<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="purpose.isClosed" />
									</div>
								</div>
											
								<div class="row mb-3">
									<div class="col-md-3"></div>
												
									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.purpose.$invalid || isLoading" @click="identifier == null ? save() : update()" label="Save"/>
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
													
										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import purposeApi from "@/api/purpose-api";
	import statusMixin from "@/mixin/status";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";

	import useVuelidate from "@vuelidate/core"
	import { required } from "@vuelidate/validators"
	
	export default defineComponent({
		mixins: [statusMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				purpose: {code: '', name: '', suffix: '', isClosed: false},
				isPageLoading: false,
				isLoading: false,
				isDeleting: false,
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				if (this.identifier != null) {
					this.isPageLoading = true;
					purposeApi.purposeView(this.identifier)
						.then(response => {
							this.purpose = response.data.purpose;
							this.isPageLoading = false;
						})
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}
			}
		},
		methods: {
			save() {
				this.isLoading = true;
				purposeApi.purposeSave({
						purpose: this.purpose
					})
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						this.$router.push("/admin/purpose");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
				purposeApi.purposeUpdate({
						purpose: this.purpose
					})
					.then(response => {
						this.isLoading = false;
						this.$router.push("/admin/purpose");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			deletePurpose() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this purpose?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						purposeApi.purposeDelete({
								purpose: this.purpose
							})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/admin/purpose");
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			cancel() {
				this.$router.push("/admin/purpose");
			},
			toggleTips(event: any) {
				(this.$refs.suffixTips as any).toggle(event);
			}
		},
		setup() {
			return { v$: useVuelidate() }
		},
		validations() {
			return {
				purpose : {
					code: {
						required
					},
					name: {
						required
					},
					isClosed: {
						required
					},
				}
			}
		}
	});
</script>
